import { Controller } from '@hotwired/stimulus'

// Abre la ventana de contacto de la ficha de escuela diciéndole por qué se pregunta
// (ENH-RNK-5363).
//
// Desde la cabecera, la barra de pestañas o la barra fija, el contacto cuelga de la escuela:
// el visitante todavía no ha elegido programa. Desde la tarjeta de un programa cuelga de ese
// programa, y la ventana lo dice en su cabecera, que es lo que pide el artefacto.
//
// La ventana es una sola para toda la página: rellenarla aquí evita repetir el formulario —y
// sus dos consentimientos— en cada una de las tarjetas.
const VENTANA = '#contactar-escuela'

export default class extends Controller {
  static values = { programa: String, programaId: Number }

  abrir () {
    const ventana = document.querySelector(VENTANA)
    if (!ventana) return

    this.volverAlFormulario(ventana)
    this.anotarOrigen(ventana)
    ventana.open()
  }

  // Tras un envío la ventana se queda mostrando la confirmación. Quien vuelve a pedir
  // contacto —desde la barra fija o desde la tarjeta de otro programa— espera el formulario,
  // no el acuse del envío anterior. Los dos bloques siguen en el documento, así que basta con
  // cambiar cuál se ve.
  volverAlFormulario (ventana) {
    const formulario = ventana.querySelector('[data-escuelas-contacto-target="formulario"]')
    const enviado = ventana.querySelector('[data-escuelas-contacto-target="enviado"]')

    if (formulario) formulario.hidden = false
    if (enviado) enviado.hidden = true
  }

  anotarOrigen (ventana) {
    const tipo = ventana.querySelector('[name="lead_negocios[origen_type]"]')
    const id = ventana.querySelector('[name="lead_negocios[origen_id]"]')
    const sobre = ventana.querySelector('[data-programa]')
    const entrada = ventana.querySelector('.rnk-Escuelas_ContactoEntrada')
    const esPrograma = this.hasProgramaIdValue && this.programaIdValue > 0

    if (tipo) tipo.value = esPrograma ? 'CursoDeNegocios' : 'EscuelaDeNegocios'
    if (id) id.value = esPrograma ? this.programaIdValue : ''

    // Uno u otro, nunca los dos: el prototipo tiene ahí un único rótulo que cambia de texto
    // («Sobre: <programa>» o la bajada). Preguntando por un programa concreto, «te llamamos
    // para resolver tus dudas» no añade nada.
    if (entrada) entrada.hidden = esPrograma
    if (!sobre) return

    sobre.textContent = esPrograma ? `Sobre: ${this.programaValue}` : ''
    sobre.hidden = !esPrograma
  }
}
